import { UsersIcon, UsersThreeIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ManageUsersContent } from '@/content/ManageUsersContent';

interface BulkSelectionActionBarProps {
  selectedCount: number;
  onClear: () => void;
  onChangeRole: () => void;
  onAddGroups: () => void;
  disabled?: boolean;
}

export function BulkSelectionActionBar({
  selectedCount,
  onClear,
  onChangeRole,
  onAddGroups,
  disabled = false,
}: BulkSelectionActionBarProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <section
      aria-label="Bulk edit actions"
      className="fixed inset-x-0 bottom-[calc(7rem+max(1.5rem,env(safe-area-inset-bottom)))] z-[60] px-3"
    >
      <div className="mx-auto max-w-4xl">
        <div
          className={cn(
            'overflow-hidden rounded-[22px] border border-white/15 shadow-[0_12px_36px_rgba(0,0,0,0.45)]',
            'bg-slate-600/80 backdrop-blur-xl supports-[backdrop-filter]:bg-slate-600/75'
          )}
        >
          <div className="p-3">
            <div className="mb-2 flex items-center justify-between gap-3">
              <span className="text-body text-slate-50">
                {ManageUsersContent.bulkEdit.selectionCount(selectedCount)}
              </span>
              <button
                type="button"
                onClick={onClear}
                className="rounded-full px-2 py-1 font-field-42 text-[12px] text-slate-400 transition-colors hover:text-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300"
              >
                {ManageUsersContent.bulkEdit.clearSelection}
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={onChangeRole}
                disabled={disabled}
                className="h-11 rounded-full border-white/15 bg-white/10 px-3 text-slate-50 hover:bg-white/15"
              >
                <UsersIcon size={16} weight="bold" />
                {ManageUsersContent.bulkEdit.changeRole}
              </Button>
              <Button
                type="button"
                onClick={onAddGroups}
                disabled={disabled}
                className="h-11 rounded-full bg-green-400 px-3 text-slate-700 hover:bg-green-300"
              >
                <UsersThreeIcon size={16} weight="bold" />
                {ManageUsersContent.bulkEdit.addGroups}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
